<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/vue.png" /></div>
      <p>Axios</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/axios/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "0.27.2",
          linkList: [ur + "0.27.2/axios.js", ur + "0.27.2/axios.min.js"]
        },
        {
          label: "0.26.0",
          linkList: [ur + "0.26.0/axios.min.js"]
        },
        {
          label: "0.21.4",
          linkList: [ur + "0.21.4/axios.js", ur + "0.21.4/axios.min.js"]
        },
        {
          label: "0.19.0-beta.1",
          linkList: [
            ur + "0.19.0-beta.1/axios.js",
            ur + "0.19.0-beta.1/axios.min.js"
          ]
        },
        {
          label: "0.19.0",
          linkList: [ur + "0.19.0/axios.js", ur + "0.19.0/axios.min.js"]
        },
        {
          label: "0.18.1",
          linkList: [ur + "0.18.1/axios.js", ur + "0.18.1/axios.min.js"]
        },
        {
          label: "0.18.0",
          linkList: [ur + "0.18.0/axios.js", ur + "0.18.0/axios.min.js"]
        },
        {
          label: "0.17.1",
          linkList: [ur + "0.17.1/axios.js", ur + "0.17.1/axios.min.js"]
        },
        {
          label: "0.17.0",
          linkList: [ur + "0.17.0/axios.js", ur + "0.17.0/axios.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListAxios.vue